import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "card-header align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title d-flex flex-row justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Create new article")
], -1)
const _hoisted_5 = { class: "d-flex flex-row" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-2"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_9 = { class: "card-body p-8" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex flex-column flex-sm-row mb-4 w-100" }
const _hoisted_12 = { class: "d-flex flex-column me-0 me-sm-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "help-cat-dropdown",
  class: "form-label"
}, "Title", -1)
const _hoisted_14 = { class: "d-flex flex-column me-0 me-sm-2 my-3 my-sm-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "help-cat-dropdown",
  class: "form-label"
}, "Help category", -1)
const _hoisted_16 = { class: "d-flex flex-column ms-0 ms-sm-2 mb-2 mb-sm-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "help-cat-dropdown",
  class: "form-label"
}, "Weight", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_HelpCategoriesDropdown = _resolveComponent("HelpCategoriesDropdown")!
  const _component_tinyMceEditor = _resolveComponent("tinyMceEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary me-3",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToHelpSection && _ctx.returnToHelpSection(...args)))
          }, " Back "),
          _createElementVNode("button", {
            disabled: _ctx.isSaving,
            class: "d-flex align-items-center btn btn-sm btn-success",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSaveButton && _ctx.handleSaveButton(...args)))
          }, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : _createCommentVNode("", true),
            _hoisted_8
          ], 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_input, {
                size: "large",
                id: "help-cat-dropdown",
                modelValue: _ctx.article.title,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.article.title) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_HelpCategoriesDropdown, {
                id: "help-cat-dropdown",
                modelValue: _ctx.article.category_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.article.category_id) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_input, {
                size: "large",
                id: "help-cat-dropdown",
                modelValue: _ctx.article.weight,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.article.weight) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_tinyMceEditor, {
              modelValue: _ctx.article.text,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.article.text) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}